import "./dashboardPage.css";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { GiHamburgerMenu } from "react-icons/gi";
import { Container, Nav, Navbar, Button } from "react-bootstrap";
import { NavLink, Link, useHistory } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import userlogo from "../../../asset/img/user_logo.png";
import logo from "../../../asset/img/logo.png";
import { RiArrowRightDoubleLine } from "react-icons/ri";
import Offcanvas from "react-bootstrap/Offcanvas";
import Sidebar from "./Sidebar";
import { logout } from "../../actions/logout";
import { getWalletDetails } from "../../actions/gameSettings";
import { LIVE_SECTION_LABEL } from "../../../utility/siteCopy";
import { Images } from "../../../utility/image";
import isLogin from "../../lib/isLogin";
import NotificationBell from "../../common/NotificationBell";
import WebsiteBrandLogo from "../../common/WebsiteBrandLogo";
import { useGlobalContext } from "../../context/SocketContext";
import { formatMoney } from "../../lib/wagerFinancials";
import { WALLET_REFRESH_EVENT } from "../../../utility/walletRefresh";
import { isDTS } from "../../../utility/platform";
import CoinSwitcher from "../../common-components/CoinSwitcher";
import { COIN_MODES, getCoinModeBalance, useCoinMode } from "../../../context/CoinModeContext";
import { getGoldCoinName, getSweepsCoinName, getTerm } from "../../../utility/complianceCopy";
import { ROUTES, liveBoardPath } from "../../../constants/routes";

// Built lazily, per render: the labels read admin-configured DTS vocabulary via
// getTerm(), and site settings load asynchronously after this module is
// evaluated. A module-level array would capture the built-in defaults forever
// and never reflect an admin rename.
const getNavLinkList = () => [
  {
    labelText: isDTS()
      ? `Open ${getTerm("entry", { plural: true })}`
      : "Open Bets",
    navLink: ROUTES.openBet,
  },
  { labelText: "Fill Open", navLink: "/fillopen" },
  { labelText: "History", navLink: "/history" },
  { labelText: LIVE_SECTION_LABEL, navLink: liveBoardPath() },
];

function Header() {
  const { coinMode } = useCoinMode();
  const history = useHistory();
  const dispatch = useDispatch();
  const { socket } = useGlobalContext();
  const [show, setShow] = useState(false);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleProfile = () => history.push("/profile");
  const handleChangePassword = () => history.push("/changePassword");
  const handleTwoFactorAuth = () => history.push("/twofactorauth");
  const handleSupport = () => history.push("/support_ticket");
  const handleWallet = () => history.push("/wallet");
  // DTS-only. Both routes exist and are fully built (Stages 6/7), but until now
  // neither had a navigation entry anywhere in the app: /kyc was reachable only
  // from the "verify first" warning inside /amoe, and /amoe only from a CTA at
  // the bottom of the /info/amoe legal page. AMOE in particular is the "no
  // purchase necessary" path an underwriter expects to be as discoverable as
  // the paid one, not buried under the legal boilerplate.
  const handleKyc = () => history.push("/kyc");
  const handleAmoe = () => history.push("/amoe");
  const handleRedeem = () => history.push("/redeem");
  const handleStore = () => history.push("/storefront");
  const handleSignout = () => logout(history, dispatch);
  const handleSignIN = () => history.push("/login");
  const accountData = useSelector((state) => state.account);
  const [walletData, setWalletData] = useState({});
  const isLoggedIn = Boolean(accountData?.emailId && isLogin());

  useEffect(() => {
    if (isLoggedIn) {
      fetchWalletData();
    } else {
      setWalletData({});
    }
  }, [isLoggedIn, accountData.emailId]);

  useEffect(() => {
    const handleWalletRefresh = () => {
      fetchWalletData();
    };

    window.addEventListener(WALLET_REFRESH_EVENT, handleWalletRefresh);
    return () => {
      window.removeEventListener(WALLET_REFRESH_EVENT, handleWalletRefresh);
    };
  }, [accountData.emailId]);

  const fetchWalletData = async () => {
    if (!accountData?.emailId) {
      setWalletData({});
      return;
    }
    try {
      const { status, result } = await getWalletDetails({
        email: accountData.emailId,
      });
      if (status && result?.walletData) {
        setWalletData(result.walletData);
      } else {
        setWalletData({});
      }
    } catch (err) {
      setWalletData({});
      console.log("err", err);
    }
  };

  const availableBalance = formatMoney(walletData?.userBalance);
  const atRiskAmount = formatMoney(walletData?.riskAmount);
  const dtsActiveBalance = formatMoney(getCoinModeBalance(walletData, coinMode));
  const dtsActiveCoinName = coinMode === COIN_MODES.DREAM ? getSweepsCoinName() : getGoldCoinName();

  return (
    <div className="mg_headerComponent">
      <Navbar expand="lg" className="bg-body-tertiary common_nav" fixed="top">
        <Container className="custom_container">
          <div className="nav-contents">
            <Navbar.Brand className="p-0">
              <Link to="/" className="p-0 website-brand-logo-link">
                <WebsiteBrandLogo asLink={false} />
              </Link>
            </Navbar.Brand>

            <Navbar.Toggle
              className="mg_header_toggle"
              onClick={() => setShowOffcanvas(true)}
            />

            <Navbar.Offcanvas
              show={showOffcanvas}
              onHide={() => setShowOffcanvas(false)}
              placement="end"
              className="mg_header_offcanvas"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title>
                  <WebsiteBrandLogo asLink={false} />
                </Offcanvas.Title>
              </Offcanvas.Header>

              <Offcanvas.Body className="offCanvasBodyWrapper">
                <div className="navListWrapper fs15">
                  <ul>
                    {isDTS() && <li><CoinSwitcher wallet={walletData} /></li>}
                    {getNavLinkList().map((item, index) => (
                      <li key={index}>
                        {/* ✅ FIXED PATH HERE */}
                        <NavLink to={item.navLink}>
                          {item.labelText}
                        </NavLink>
                      </li>
                    ))}

                    <li>
                      <Dropdown className="mg-available-dropdown available fs15">
                        <Dropdown.Toggle
                          variant="light"
                          id="dropdown-available-balance"
                          aria-haspopup="true"
                          aria-label="Show available balance and risk summary"
                        >
                          <span className="mg-available-toggle-label">
                            {isDTS() ? dtsActiveCoinName : "Available($)"}
                          </span>
                          <span className="mg-available-toggle-value">
                            {isDTS() ? dtsActiveBalance : availableBalance}
                          </span>
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="mg_header_dropdown-menu mg-wallet-info-menu">
                          <Dropdown.ItemText
                            as="div"
                            className="mg-wallet-info-row mg-wallet-info-row--balance"
                          >
                            <span className="mg-wallet-info-label">{isDTS() ? `${dtsActiveCoinName}:` : "BALANCE($):"}</span>
                            <span className="mg-wallet-info-value">
                              {isDTS() ? dtsActiveBalance : availableBalance}
                            </span>
                          </Dropdown.ItemText>
                          {!isDTS() && <Dropdown.ItemText
                            as="div"
                            className="mg-wallet-info-row mg-wallet-info-row--risk"
                          >
                            <span className="mg-wallet-info-label">AT RISK($):</span>
                            <span className="mg-wallet-info-value">
                              {atRiskAmount}
                            </span>
                          </Dropdown.ItemText>}
                        </Dropdown.Menu>
                      </Dropdown>
                    </li>

                    {isLoggedIn ? (
                      <li className="notification-bell-nav-item">
                        <NotificationBell socket={socket} />
                      </li>
                    ) : null}

                    <li>
                      <Dropdown className="mg_header_dropdown mg_header_dropdown-desktop">
                          <Dropdown.Toggle variant="light" id="dropdown-account-menu">
                            <img
                              src={Images.userIcon || userlogo}
                              alt="user logo"
                              className="img-fluid user_logo"
                            />
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="mg_header_dropdown-menu">
                            {isLoggedIn ? (
                              <>
                                <Dropdown.Item onClick={handleProfile}>Profile</Dropdown.Item>
                                <Dropdown.Item onClick={handleChangePassword}>Change Password</Dropdown.Item>
                                <Dropdown.Item onClick={handleWallet}>Wallet</Dropdown.Item>
                                {isDTS() && (
                                  <>
                                    <Dropdown.Item onClick={handleStore}>Store</Dropdown.Item>
                                    <Dropdown.Item onClick={handleRedeem}>Prize Request</Dropdown.Item>
                                    <Dropdown.Item onClick={handleKyc}>
                                      Verify Identity
                                    </Dropdown.Item>
                                    <Dropdown.Item onClick={handleAmoe}>
                                      Free Entry (AMOE)
                                    </Dropdown.Item>
                                  </>
                                )}
                                <Dropdown.Item onClick={handleTwoFactorAuth}>2FA</Dropdown.Item>
                                <Dropdown.Item onClick={handleSupport}>Support Us</Dropdown.Item>
                                <Dropdown.Item onClick={handleSignout}>Sign Out</Dropdown.Item>
                              </>
                            ) : (
                              <Dropdown.Item onClick={handleSignIN}>Sign In</Dropdown.Item>
                            )}
                          </Dropdown.Menu>
                        </Dropdown>
                    </li>

                  </ul>
                </div>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </div>
        </Container>

        <Button
          variant="primary"
          onClick={handleShow}
          className="sidebarToggleBtn d-xxl-none"
        >
          <RiArrowRightDoubleLine />
        </Button>
      </Navbar>

      <Offcanvas
        show={show}
        onHide={handleClose}
        className="offcanvas_mbl_sidebar"
      >
        <Offcanvas.Body>
          <Sidebar onhide={handleClose} />
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
}

export default Header;
